import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number; 
  [key: string]: any;
}
export default {
  /**
   * Fetch the charging point list with pagination
   * @param {any} data - The data
   */
  fetchChargingPointWithoutPagination: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point`, { ...data });
  },
  /**
   * Fetch average uptime and downtime statistics for charging stations
   * @param {any} data - The data
   */
  fetchAvgOnlineOffline: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/avg-uptime-downtime`,
      { ...data },
    );
  },
  /**
   * All Devices show API
   * @param {any} query - The query
   */
  fetchDeviceList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/device-list`, {
      ...parameters,
    });
  },
  /**
   * Station Activity show API
   * @param {any} query - The query
   */
  fetchStationActivityList: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/ocpp-logs`, {
      ...parameters,
    });
  },

  /**
   * Station Activity show API
   * @param {any} query - The query
   */
  fetchStationActivityExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/ocpp-logs-export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Station Activity show API
   * @param {any} query - The query
   */
  fetchStationActivityListFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/ocpp-logs/list-filters`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Station management's station details chart api
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the chart data
   */
  fetchStationChartData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/time-based-transaction-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Station management's station details data api
   * @param {any} id - The station ID
   * @param {any} query - The query
   * @returns {any} A promise that resolves with the station details
   */
  fetchStationDetails: (id: string, query?: QueryParameters) => {
    console.log('Getting ID:', id);
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/${id}`, query);
  },
  /**
   * Station Activity show API
   * @param {any} query - The query
   */
  fetchConnectorStatus: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/connector-status`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchTransactionList: (query: QueryParameters) => {
    const sn = query?.chargingPointSn || query?.chargingpointsn;
    const accountCustomIdValue = query?.accountCustomId;
    const station = query?.stationId || query?.chargingStation;

    const parameters: Record<string, any> = {
      ...query,
      limit: query?.limit || DefaultApiLimit.limit,
    };
    delete parameters.chargingpointsn;
    delete parameters.chargingPointSn;
    delete parameters.accountCustomId;
    delete parameters.chargingStation;
    delete parameters.stationId;

    if (sn) {
      parameters.chargingPointSn = Array.isArray(sn) ? sn : [sn];
    }
    if (accountCustomIdValue) {
      parameters.accountCustomId = Array.isArray(accountCustomIdValue)
        ? accountCustomIdValue
        : [accountCustomIdValue];
    }
    if (station) {
      parameters.stationId = Array.isArray(station) ? station : [station];
    }

    return getRequest(
      `${config.cpo.transactionApiUrl}api/common/v1/charging-transaction/transaction-list`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @returns {any} A promise that resolves with the filter list
   */
  fetchTransactionListFilter: () => {
    return getRequest(
      `${config.cpo.transactionApiUrl}api/common/v1/charging-transaction/transaction-list/filter-list`,
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchTransactionListExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-transaction/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchTransactionChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/power-consumption-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchGuestChargingList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/free-charging-schedules`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchGuestChargingchart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/schedule-charging-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Guest charging filter
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the filters
   */
  fetchGuestChargingListFilter: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/free-charging-schedules/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Guest charging
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchGuestChargingListExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/free-charging-schedules/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchMaintenanceSchedule: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule`,
      {
        ...parameters,
      },
    );
  },
  /**
   * maintenance schedule export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchMaintenanceScheduleExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule/export-data`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Maintenance schedule filters
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the filters
   */
  fetchMaintenanceScheduleFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule-report/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transactions show API
   * @param {any} query - The query
   */
  fetchMaintenanceCalendars: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab summary list with pagination
   * @param {any} query - The query
   */
  fetchReportSummary: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-report-overview`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab summary list with pagination
   * @param {any} query - The query
   */
  fetchReportSummaryExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-report-overview/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab summary list with pagination
   * @param {any} query - The query
   */
  fetchReportSummaryFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-report-overview/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Revenue & Energy Trends
   * @param {any} query - The query
   */
  fetchReportPowerConsumed: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-power-consumption`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Revenue & Energy Trends
   * @param {any} query - The query
   */
  fetchRevenueChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/power-consumption-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   * @param {any} query - The query
   */
  fetchReportUtilization: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-utilization`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   * @param {any} query - The query
   */
  fetchReportUtilizationExport: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-utilization/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   * @param {any} query - The query
   */
  fetchReportUtilizationFilters: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-utilization/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching charging station list
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the charging stations list
   */
  fetchChargingStationList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-list`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   * @param {any} query - The query
   */
  fetchDevicesList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-list`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Add lane map API
   * @param {any} chargingStationId - The charging station ID
   * @param {any} data - The lane data payload
   * @returns {any} A promise that resolves with the post response
   */
  addLaneMap: (chargingStationId: string | number, data: any): Promise<any> => {
    return postRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station-map/${chargingStationId}`,
      data,
      true,
    );
  },
  /**
   * Edit schedule API add lane or edit lane api
   * @param {any} chargingStationId - The charging station ID
   * @param {any} laneMapId - The lane map ID to edit
   * @param {any} data - The lane data payload
   * @returns {any} A promise that resolves with the edit response
   */
  editLaneMap: (
    chargingStationId: number | string,
    laneMapId: number | string,
    data: any,
  ): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station-map/${chargingStationId}/${laneMapId}`,
      data,
      true,
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   * @param {any} query - The query
   */
  fetchLaneMapList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station-map`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Station performance tab Historical Faults list with pagination
   * @param {any} query - The query
   */
  fetchHistoricalFaultsList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/historical-fault-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching historical fault list filter
   * @param {any} query - The query
   */
  fetchHistoricalFaultsListFilter: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/historical-fault-report/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching historical fault list filter
   * @param {any} query - The query
   */
  fetchHistoricalFaultsListExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/historical-fault-report/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Station performance chart heat map hour
   * @param {any} query - The query
   */
  fetchHeatMapByHour: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/transaction-duration-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the station Compariosn tab Historical Faults list with pagination
   * @param {any} query - The query
   */
  fetchSessionCountPerStationChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/session-count-per-station`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the station Comparison  chart
   * @param {any} query - The query
   */
  fetchEnergyRevenueComparison: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-comparison-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * fetching heat map chart's data
   */
  fetchHeatMapChartData: () => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/transaction-duration-report`,
    );
  },
  /**
   * Station Activity show API
   * @param {any} query - The query
   */
  fetchAlertsList: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/alerts`, {
      ...parameters,
    });
  },
  /**
   * Alerts List show API
   * @param {any} query - The query
   */
  fetchAlertsExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/alerts-export`, {
      ...parameters,
    });
  },
  /**
   * Alerts List Filters show API
   * @param {any} query - The query
   */
  fetchAlertsListFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/alerts/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Alerts Chart show API
   * @param {any} query - The query
   */
  fetchAlertsChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/alerts-report`, {
      ...parameters,
    });
  },
  /**
   * Alerts Chart show API
   * @param {any} query - The query
   */
  fetchAlertsPointInfo: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/alerts-charging-point-info`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Station performance uptime by station chart
   * @param {any} query - The query
   */
  fetchUptimeChartData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/uptime-by-station`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Station performance uptime by station chart
   * @param {any} query - The query
   */
  fetchUptimeOverTimeChartData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/uptime-trend-over-time`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching no of schedules
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the number of schedules
   */
  fetchNoOfSchedules: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/station-schedule-hours`,
      { ...parameters },
    );
  },
  /**
   * Fetching no of Uptime list and chart
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the uptime list and chart data
   */
  fetchUptimeListAndChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-consumption-month-wise`,
      { ...parameters },
    );
  },
  /**
   * Fetching today's uptime
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with today's uptime data
   */
  fetUpTimeTodayData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-consumption-date-wise`,
      { ...parameters },
    );
  },
  /**
   * updating guest status
   * @param {any} id - The guest ID
   * @param {any} data - The status data payload
   * @returns {any} A promise that resolves with the update response
   */
  updateGuestStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/free-charging/updateActiveStatus/${id}`,
      data,
      false,
    );
  },
  /**
   * Station Activity show API
   * @param {any} query - The query
   */
  fetchVehicleInformation: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-station/get-vehicle-information`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Get device connector status count
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the status count response
   */
  getDeviceConnectorStatus: (query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/device-connector-status-count`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Get station device status count
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the device status count response
   */
  getStationDeviceStatusCount: (query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/station-device-status-count`,
      {
        ...parameters,
      },
    );
  },
};
